import { Rail } from "@circle-react-uikit/Rail";
import { RailBarPortal } from "@circle-react/components/Layout/LegacyBridge";
import { useChatParticipantsApi } from "@circle-react/hooks/chatsV2/useChatParticipantsApi";
import { useRailbar } from "@circle-react/hooks/chatsV2/useRailbar";
import { useElementHeight } from "@circle-react/hooks/utils/useElementHeight";

import { ChatRoomDescription } from "@/react/components/Chat/MessagingV2/RailBar/ChatRoomDescription";
import type { Space } from "@/react/types/Space";

import { Content } from "./Content";
import { Header } from "./HeaderCompass";

interface RailBarProps {
  space: Space;
}

const RailBar = ({ space }: RailBarProps) => {
  const {
    chatParticipants,
    isLoading: isChatParticipantsLoading,
    refetchChatParticipants,
    hasNextPage,
    fetchNextPage,
  } = useChatParticipantsApi(space.chat_room_uuid, {
    shouldDisableCache: true,
    per_page: 25,
  });
  const { toggleShowRailBar } = useRailbar();
  const { ref: headerRef, height: headerHeight } = useElementHeight();

  return (
    <RailBarPortal
      isLoading={isChatParticipantsLoading}
      loaderVariant="rail-member-list"
    >
      <Rail.Header>
        <div ref={headerRef} className="w-full">
          <Header onClose={toggleShowRailBar} />
        </div>
      </Rail.Header>
      <Rail.Content heightGap={headerHeight} noPadding>
        <ChatRoomDescription
          description={space.chat_room_description || ""}
          className="pb-2"
        />
        <Content
          spaceMembers={chatParticipants}
          hasMoreSpaceMembers={hasNextPage}
          space={space}
          refetchSpaceMembers={refetchChatParticipants}
          fetchNextPage={fetchNextPage}
        />
      </Rail.Content>
    </RailBarPortal>
  );
};

export { RailBar };
